module.exports = {
	"ranks": [
		"Tenderpaw",
		"Guardmouse",
		"Patrol Guard",
		"Patrol Leader",
		"Guard Captain"
	],
	"bases": {
		"default": {
			"Name": "p310",
			"Parents": "",
			"Age": "",
			"Senior Artisan": "",
			"Home": "",
			"Mentor": "",
			"Fur Color": "Brown, Blonde, Gray, Black, Red",
			"Rank": "",
			"Cloak": "Choose a color",
			"Enemy": "p310",
			"Friend": "p310",
			"Nature": 3,
			"Will": 0,
			"Health": 0,
			"Resources": 0,
			"Circles": 0,
			"Belief": "Choose an ideal p42",
			"Goal": "Leave blank (chosen each session after mission briefing p45)",
			"Instinct": "Choose something you do a lot p47",
			"Skills": {},
			"Wises": {},
			"Traits": {},
			"Gear": "Choose 1 weapon and some simple items",
			"saveForWinter": false,
			"fearWeasels": false,
			"wiseChoices": 0
		},
		"Tenderpaw": {
			"Age": "14-17",
			"Cloak": "None",
			"Will": 3,
			"Health": 6,
			"Skills": {
				"Pathfinder": 2,
				"Scout": 2,
				"Laborer": 2
			},
			"Circles": 1,
			"Resources": 1
		},
		"Guardmouse": {
			"Age": "18-25",
			"Will": 3,
			"Health": 5,
			"Skills": {
				"Fighter": 3,
				"Haggler": 2,
				"Pathfinder": 3,
				"Scout": 2,
				"Survivalist": 2
			},
			"wiseChoices": 1,
			"Circles": 2,
			"Resources": 2
		},
		"Patrol Guard": {
			"Age": "21-50",
			"Will": 4,
			"Health": 4,
			"Skills": {
				"Cook": 2,
				"Fighter": 3,
				"Hunter": 3,
				"Scout": 2,
				"Healer": 2,
				"Pathfinder": 2,
				"Survivalist": 2,
				"Weather Watcher": 2
			},
			"wiseChoices": 2,
			"Circles": 3,
			"Resources": 3
		},
		"Patrol Leader": {
			"Age": "21-60",
			"Will": 5,
			"Health": 4,
			"Skills": {
				"Fighter": 3,
				"Hunter": 3,
				"Instructor": 2,
				"Loremouse": 2,
				"Persuader": 2,
				"Pathfinder": 2,
				"Scout": 2,
				"Survivalist": 3,
				"Weather Watcher": 2
			},
			"wiseChoices": 3,
			"Circles": 3,
			"Resources": 4
		},
		"Guard Captain": {
			"Age": "41-60",
			"Will": 6,
			"Health": 3,
			"Skills": {
				"Administrator": 3,
				"Fighter": 3,
				"Healer": 2,
				"Hunter": 3,
				"Instructor": 2,
				"Militarist": 3,
				"Orator": 2,
				"Pathfinder": 3,
				"Scout": 3,
				"Survivalist": 3,
				"Weather Watcher": 3
			},
			"wiseChoices": 3,
			"Circles": 4,
			"Resources": 5
		}
	},
	"homes": {
		"Barkstone": {
			"book": "MG2e",
			"page": 170,
			"skills": [
				"Carpenter",
				"Potter",
				"Glazier"
			],
			"traits": [
				"Steady Paw"
			]
		},
		"Copperwood": {
			"book": "MG2e",
			"page": 170,
			"skills": [
				"Smith",
				"Haggler"
			],
			"traits": [
				"Independent"
			]
		},
		"Elmoss": {
			"book": "MG2e",
			"page": 172,
			"skills": [
				"Carpenter",
				"Harvester"
			],
			"traits": [
				"Alert"
			]
		},
		"Flintrust": {
			"book": "NRNM",
			"page": 8,
			"skills": [
				"Smith",
				"Laborer"
			],
			"traits": [
				"Bold",
				"Determined"
			]
		},
		"Grasslake": {
			"book": "NRNM",
			"page": 10,
			"skills": [
				"Insectrist",
				"Militarist"
			],
			"traits": [
				"Nimble",
				"Defender"
			]
		},
		"Ivydale": {
			"book": "MG2e",
			"page": 173,
			"skills": [
				"Harvester",
				"Baker"
			],
			"traits": [
				"Hard Worker"
			]
		},
		"Lockhaven": {
			"book": "MG2e",
			"page": 174,
			"skills": [
				"Weaver",
				"Armorer"
			],
			"traits": [
				"Generous",
				"Guard's Honor"
			]
		},
		"Port Sumac": {
			"book": "MG2e",
			"page": 175,
			"skills": [
				"Boatcrafter",
				"Weather Watcher"
			],
			"traits": [
				"Tough",
				"Weather Sense"
			]
		},
		"Sandmason": {
			"book": "NRNM",
			"page": 9,
			"skills": [
				"Weather Watcher",
				"Glazier"
			],
			"traits": [
				"Nocturnal",
				"Quiet"
			]
		},
		"Shaleburrow": {
			"book": "MG2e",
			"page": 176,
			"skills": [
				"Mason",
				"Harvester",
				"Miller"
			],
			"traits": [
				"Open-Minded"
			]
		},
		"Sprucetuck": {
			"book": "MG2e",
			"page": 177,
			"skills": [
				"Scientist",
				"Loremouse"
			],
			"traits": [
				"Inquisitive",
				"Rational"
			]
		}
	},
	"skills": [
		"Administrator",
		"Apiarist",
		"Archivist",
		"Armorer",
		"Baker",
		"Boatcrafter",
		"Brewer",
		"Carpenter",
		"Cartographer",
		"Cook",
		"Manipulator",
		"Fighter",
		"Glazier",
		"Haggler",
		"Harvester",
		"Healer",
		"Hunter",
		"Insectrist",
		"Instructor",
		"Laborer",
		"Loremouse",
		"Militarist",
		"Miller",
		"Orator",
		"Pathfinder",
		"Persuader",
		"Potter",
		"Scientist",
		"Scout",
		"Smith",
		"Stonemason",
		"Survivalist",
		"Weather Watcher",
		"Weaver"
	],
	"parentSkills": [
		"Apiarist",
		"Archivist",
		"Armorer",
		"Baker",
		"Boatcrafter",
		"Brewer",
		"Carpenter",
		"Cartographer",
		"Glazier",
		"Harvester",
		"Insectrist",
		"Miller",
		"Potter",
		"Smith",
		"Stonemason",
		"Weaver"
	],
	"conviceSkills": [
		"Manipulator",
		"Orator",
		"Persuader"
	],
	"seniorArtisanSkills": [
		"Apiarist",
		"Archivist",
		"Armorer",
		"Baker",
		"Brewer",
		"Carpenter",
		"Cartographer",
		"Cook",
		"Glazier",
		"Harvester",
		"Healer",
		"Insectrist",
		"Laborer",
		"Miller",
		"Potter",
		"Smith",
		"Stonemason",
		"Weaver"
	],
	"mentorSkills": [
		"Fighter",
		"Healer",
		"Hunter",
		"Instructor",
		"Pathfinder",
		"Scout",
		"Survivalist",
		"Weather Watcher"
	],
	"generousTraits": [
		"Bold",
		"Generous",
		"Impetuous"
	],
	"braveTraits": [
		"Fearless",
		"Brave",
		"Foolish"
	],
	"tenderpawWises": [
		"Code of the Guard",
		"Legends of the Guard"
	],
	"guardCaptainWises": [
		"Lockhaven",
		"Matriarch"
	],
	"wises": [
		"Apiary",
		"Armor",
		"Autumn storm",
		"Badger",
		"Barkstone",
		"Bird",
		"Blizzard",
		"Bramble",
		"Brush fire",
		"Burrow",
		"Celebrations",
		"Clear and warm weather",
		"Coast",
		"Cold rain",
		"Cold snap",
		"Copperwood",
		"Coyote",
		"Craft",
		"Crime",
		"Darkheather",
		"Deer",
		"Drought",
		"Elmoss",
		"Epidemic",
		"Escort",
		"Famine",
		"Flash flood",
		"Forest fire",
		"Forest",
		"Fox",
		"Freezing",
		"Frog",
		"Governor",
		"Grain",
		"Guard captain",
		"Guardmouse",
		"Harvest",
		"Hawk",
		"Heat wave",
		"Herb",
		"Hidey hole",
		"Ice storm",
		"Ice",
		"Lake",
		"Leaf cover",
		"Lockhaven",
		"Mail",
		"Medicine",
		"Moose",
		"Moss",
		"Mouse Guard",
		"Mud",
		"Night",
		"Nut",
		"Open ground",
		"Owl",
		"Path",
		"Patrol guard",
		"Patrol leader",
		"Planting",
		"Poison",
		"Pond",
		"Predator",
		"Raccoon",
		"Rain",
		"Raven",
		"Rebellion",
		"Recipe",
		"Road",
		"Rocky terrain",
		"Scent Border",
		"Shaleburrow",
		"Shield",
		"Shore",
		"Shortages",
		"Snake",
		"Snow",
		"Sprucetuck",
		"Squirrel",
		"Star",
		"Stream",
		"Swamps",
		"Tall grass",
		"Tenderpaw",
		"Thorn",
		"Thunderstorm",
		"Tide",
		"Tradesmouse",
		"Trail",
		"Transport",
		"Trap",
		"Tunnel",
		"Turtle",
		"Unseasonably cold",
		"Unseasonably warm",
		"War",
		"Weasel",
		"Widget",
		"Wild country",
		"Wild mouse",
		"Wolf"
	],
	"traits": [
		"Bigpaw",
		"Bitter",
		"Bodyguard",
		"Bold",
		"Brave",
		"Calm",
		"Clever",
		"Compassionate",
		"Cunning",
		"Curious",
		"Deep Ear",
		"Defender",
		"Determined",
		"Driven",
		"Early Riser",
		"Extrovert",
		"Fat",
		"Fearful",
		"Fearless",
		"Fiery",
		"Generous",
		"Graceful",
		"Guard’s Honor",
		"Innocent",
		"Jaded",
		"Leader",
		"Longtail",
		"Lost",
		"Natural Bearings",
		"Nimble",
		"Nocturnal",
		"Oldfur",
		"Quick-Witted",
		"Quiet",
		"Scarred",
		"Sharp-Eyed",
		"Sharptooth",
		"Short",
		"Skeptical",
		"Skinny",
		"Stoic",
		"Stubborn",
		"Suspicious",
		"Tall",
		"Thoughtful",
		"Tough",
		"Weather Sense",
		"Wise",
		"Wolf’s Snout",
		"Young"
	],
	"tenderpawTraits": [
		"Bigpaw",
		"Brave",
		"Calm",
		"Clever",
		"Compassionate",
		"Curious",
		"Deep Ear",
		"Defender",
		"Determined",
		"Driven",
		"Early Riser",
		"Extrovert",
		"Fearful",
		"Fearless",
		"Fiery",
		"Generous",
		"Graceful",
		"Longtail",
		"Lost",
		"Natural Bearings",
		"Nimble",
		"Quick-Witted",
		"Quiet",
		"Scarred",
		"Sharptooth",
		"Short",
		"Skeptical",
		"Skinny",
		"Stubborn",
		"Suspicious",
		"Tall",
		"Tough",
		"Wolf’s Snout"
	],
	"guardCaptainTraits": [
		"Bitter",
		"Bodyguard",
		"Brave",
		"Calm",
		"Clever",
		"Compassionate",
		"Cunning",
		"Curious",
		"Defender",
		"Driven",
		"Early Riser",
		"Fearful",
		"Fearless",
		"Jaded",
		"Leader",
		"Natural Bearings",
		"Nocturnal",
		"Oldfur",
		"Quiet",
		"Scarred",
		"Sharp-Eyed",
		"Skeptical",
		"Skinny",
		"Stoic",
		"Thoughtful",
		"Tough",
		"Weather Sense",
		"Wise"
	],
	"furColor": [
		"Brown",
		"Blonde",
		"Gray",
		"Black",
		"Red"
	],
	"names": [
		"Abram",
		"Aengus",
		"Algomin",
		"Beagan",
		"Brand",
		"Cale",
		"Caley",
		"Connor",
		"Curt",
		"Faolan",
		"Finn",
		"Folker",
		"Gamlion",
		"Garnier",
		"Garrow",
		"Grahame",
		"Gurney",
		"Hannidy",
		"Henson",
		"Jasper",
		"Joseph",
		"Kole",
		"Laird",
		"Noelan",
		"Seyth",
		"Sloan",
		"Tander",
		"Thom",
		"Thurstan",
		"Trevor",
		"Vidar",
		"Walmond",
		"Autumn",
		"Aynselle",
		"Baeylie",
		"Brynn",
		"Caley",
		"Clove",
		"Daewn",
		"Dalla",
		"Daye",
		"Gale",
		"Ingrid",
		"Ivy",
		"Josephine",
		"Julyia",
		"Kearra",
		"Laurel",
		"Lilly",
		"Loonis",
		"Loralai",
		"Maren",
		"Millicent",
		"Moira",
		"Nola",
		"Quinn",
		"Rona",
		"Rosalee",
		"Sayble",
		"Serra",
		"Sloan",
		"Sylvia",
		"Taryn",
		"Tinble",
		"Veira",
		"Asel",
		"Boris",
		"Chester",
		"Colin",
		"Demitri",
		"Duncan",
		"Elis",
		"Elric",
		"Gregory",
		"Hamon",
		"Larkin",
		"Lawrence",
		"Tenny",
		"Vladimir",
		"Wilkin",
		"Aster",
		"Blossom",
		"Bluebell",
		"Eda",
		"Flora",
		"Faye",
		"Mildred"
	],
	"npcSkills": [
		"Armorer",
		" Baker",
		"Apiarist",
		"Insectrist",
		"Administrator",
		"Magistrate",
		"Judge",
		"Archivist",
		"Boatcrafter",
		"Brewer",
		"Innkeeper",
		"Carpenter",
		"Cartographer",
		"Cook",
		"Miner",
		"Bandit",
		"Thief",
		"Swindler",
		"Fighter",
		"Glazier",
		"Haggler",
		"Peddler",
		"Harvester",
		"Healer",
		"Hunter",
		"Instructor",
		"Laborer",
		"Loremouse",
		"Advisor",
		"Town Guardsmouse",
		"Strategist",
		"Militarist",
		"Miller",
		"Barmouse",
		"Orator",
		"Deceiver",
		"Pathfinder",
		"Persuader",
		"Potter",
		"Scientist",
		"Scout",
		"Weapon Smith",
		"Tool Smith",
		"Stonemason",
		"Historian",
		"Gatekeeper",
		"Survivalist",
		"Hermit",
		"Weather Watcher",
		"Weaver",
		"Naturalist",
		"Politician",
		"Merchant",
		"Guard Aaptain",
		"Patrol Leader",
		"Patrol Guard",
		"Guardmouse",
		"Tenderpaw",
		"Beetle Wrangler",
		"Boatmouse",
		"Charlatan",
		"Forager",
		"Merchant",
		"Muscle",
		"Mercenary",
		"Naturalist",
		"Soldier",
		"Teacher",
		"Town Captian",
		"Wanderer"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/config/character.json
 ** module id = 120
 ** module chunks = 0
 **/